import { render, staticRenderFns } from "./FormStep.vue?vue&type=template&id=6fc91fb6"
import script from "./FormStep.vue?vue&type=script&lang=js"
export * from "./FormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc91fb6')) {
      api.createRecord('6fc91fb6', component.options)
    } else {
      api.reload('6fc91fb6', component.options)
    }
    module.hot.accept("./FormStep.vue?vue&type=template&id=6fc91fb6", function () {
      api.rerender('6fc91fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/europe40under40-design-award/components/FormStep.vue"
export default component.exports